import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const FireExtinguisher = ({
	size,
	...props
}: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M22 8.101V6H25C25.552 6 26 5.552 26 5C26 4.448 25.552 4 25 4H21.828C21.415 2.836 20.304 2 19 2H17C15.681 2 14.559 2.856 14.158 4.041C9.589 4.467 6 8.322 6 13V25C6 25.552 6.448 26 7 26C7.552 26 8 25.552 8 25V22H10V27C10 28.654 11.346 30 13 30H23C24.654 30 26 28.654 26 27V13C26 10.585 24.279 8.565 22 8.101V8.101ZM16 5C16 4.449 16.449 4 17 4H19C19.551 4 20 4.449 20 5V8H16V5ZM8 20V13C8 9.48 10.612 6.559 14 6.073V8.101C11.721 8.565 10 10.586 10 13V20H8ZM24 22H21C20.449 22 20 21.551 20 21V17C20 16.449 20.449 16 21 16H24V22ZM24 14H21C19.346 14 18 15.346 18 17V21C18 22.654 19.346 24 21 24H24V27C24 27.551 23.551 28 23 28H13C12.449 28 12 27.551 12 27V13C12 11.346 13.346 10 15 10H21C22.654 10 24 11.346 24 13V14Z" />
	</svg>
);

export default FireExtinguisher;
